import { Checkbox, FormControlLabel } from '@mui/material';
import React from 'react';

type Props = {
  checked: boolean;
  onChange: (x: boolean) => void;
  label?: React.ReactNode;
  style?: React.CSSProperties;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  size?: 'small' | 'medium' | 'large';
};

const EdCheckbox: React.FC<Props> = (props) => {
  const { label, checked, onChange, style, onClick, size, ...other } = props;
  if (label) {
    return (
      <FormControlLabel
        style={{ width: '100%', height: '100%', ...style }}
        control={
          <Checkbox
            checked={checked}
            onClick={(e) => (onClick ? onClick(e) : {})}
            onChange={(e) => onChange(!checked)}
            value="checkbox"
            color="primary"
            inputProps={{ 'aria-label': 'secondary checkbox' }}
          />
        }
        label={label}
        {...other}
      />
    );
  }

  return (
    <Checkbox
      checked={checked}
      onChange={(event) => onChange(!checked)}
      onClick={(e) => (onClick ? onClick(e) : {})}
      value="checkbox"
      color="primary"
      inputProps={{ 'aria-label': 'secondary checkbox' }}
    />
  );
};

export default EdCheckbox;
